export default {
  header: {
    logout: 'Log out',
    myAccount: 'My account',
    myProfile: 'My profile'
  }
}
